module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/6.9e537eee.png";